import {
  type DocumentNode,
  type MutationHookOptions,
  type OperationVariables,
  useMutation,
} from "@apollo/client";
import {
  CreateEmailTemplateMutation,
  DeleteEmailTemplatesMutation,
  SendTestEmailTemplateMutation,
  UpdateEmailTemplateMutation,
} from "../graphql/mutations";
import type {
  CreateEmailTemplateMutationType,
  CreateEmailTemplateMutationVariablesType,
  DeleteEmailTemplatesMutationType,
  DeleteEmailTemplatesMutationVariablesType,
  SendTestEmailTemplateMutationType,
  SendTestEmailTemplateMutationVariablesType,
  UpdateEmailTemplateMutationType,
  UpdateEmailTemplateMutationVariablesType,
} from "@/types/graphql/partner.generated";

// Список перечитывается после каждой мутации (по образцу entities/polls):
// состав и заголовки меняются, а кеш по id не добавит новый элемент в
// список. Перечитываются только смонтированные запросы с этими именами.
const REFETCH = {
  refetchQueries: ["EmailTemplatesList", "EmailTemplate"],
};

const useRefetchingMutation = <TData, TVariables extends OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>
) => useMutation<TData, TVariables>(mutation, { ...REFETCH, ...options });

export const useCreateEmailTemplateMutation = (
  options?: MutationHookOptions<
    CreateEmailTemplateMutationType,
    CreateEmailTemplateMutationVariablesType
  >
) => useRefetchingMutation(CreateEmailTemplateMutation, options);

export const useUpdateEmailTemplateMutation = (
  options?: MutationHookOptions<
    UpdateEmailTemplateMutationType,
    UpdateEmailTemplateMutationVariablesType
  >
) => useRefetchingMutation(UpdateEmailTemplateMutation, options);

export const useDeleteEmailTemplatesMutation = (
  options?: MutationHookOptions<
    DeleteEmailTemplatesMutationType,
    DeleteEmailTemplatesMutationVariablesType
  >
) => useRefetchingMutation(DeleteEmailTemplatesMutation, options);

// Тестовая отправка не меняет ни библиотеку, ни квоту в кеше (спека, фаза
// 1: тестовая отправка себе идёт мимо счётчиков), поэтому без refetch.
export const useSendTestEmailTemplateMutation = (
  options?: MutationHookOptions<
    SendTestEmailTemplateMutationType,
    SendTestEmailTemplateMutationVariablesType
  >
) =>
  useMutation<
    SendTestEmailTemplateMutationType,
    SendTestEmailTemplateMutationVariablesType
  >(SendTestEmailTemplateMutation, options);
